import { TaskStatusReason } from '@cibo/core'
import { ResponsiveDialog, useReasonMessages } from '@cibo/ui'
import { LoadingButton } from '@mui/lab'
import { Box, Button, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

export type ConfirmIneligibleUserDialogProps = {
  onClose(): void
  onConfirm(): void
  open: boolean
  reasons?: TaskStatusReason[]
}

export const ConfirmIneligibleUserDialog = ({
  onClose,
  onConfirm,
  open,
  reasons,
}: ConfirmIneligibleUserDialogProps) => {
  const { t } = useTranslation('@cibo/programs/ConfirmIneligibleUserDialog')
  const { byReasonCode } = useReasonMessages()

  return (
    <ResponsiveDialog open={open} onClose={onClose}>
      <DialogTitle sx={{ width: 384 }}>{t('title')}</DialogTitle>

      <DialogContent>
        <Typography>{t('wishToMoveForward')}</Typography>
        <Box sx={{ m: 2 }}>
          <ul style={{ listStyle: 'disc' }}>
            {reasons?.[0].reasons.map(({ reason, traitId }) => (
              <li key={reason}>{byReasonCode({ reasonCode: reason, traitId })}</li>
            ))}
          </ul>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button color="secondary" onClick={onClose}>
          {t('keepEditing', { ns: '@cibo/programs/ConfirmIneligibleDialog' })}
        </Button>
        <LoadingButton variant="contained" onClick={onConfirm}>
          {t('confirm', { ns: '@cibo/programs/ConfirmIneligibleDialog' })}
        </LoadingButton>
      </DialogActions>
    </ResponsiveDialog>
  )
}
